import { Icon } from '@dev-spendesk/grapes';

import { EllipsisTooltip } from 'src/core/common/components/EllipsisTooltip';
import { StaticImageMap } from 'src/core/common/components/Map/StaticImageMap';
import appConfig from 'src/core/config';
import { VerticalLine } from 'src/core/modules/requests/components/common/VerticalLine';
import { logger } from 'src/utils/datadog-log-wrapper';

type Props = {
  locationsDescriptions: string[];
  journeyPath?: string;
};

export const LocationsCard = ({
  locationsDescriptions,
  journeyPath,
}: Props) => {
  const locations = locationsDescriptions.map((locationDescription, index) => {
    const isLastLocation = index === locationsDescriptions.length - 1;

    const iconMileage = isLastLocation ? 'flag-checkered' : 'map-pin';

    const description = (
      <div
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        className="text-content-primary flex items-center"
      >
        <Icon
          name={iconMileage}
          size="s"
          className="text-decorative-icon mr-16"
        />
        <EllipsisTooltip text={locationDescription} />
      </div>
    );

    if (isLastLocation) {
      return description;
    }

    return (
      // eslint-disable-next-line react/no-array-index-key
      <div key={index + locationDescription}>
        {description}
        <div className="text-content-disabled -my-[2px] flex w-12 justify-center">
          <VerticalLine height={12} />
        </div>
      </div>
    );
  });

  if (!journeyPath) {
    return (
      <div className="box p-0">
        <div className="p-16">{locations}</div>
      </div>
    );
  }

  let path;
  try {
    path = JSON.parse(journeyPath ?? '[]');
  } catch {
    logger.error('Could not parse the journey path for the mileage', {
      team: 'travel-and-expenses',
      scope: 'mileage::map',
    });
  }

  if (!appConfig.showMileageStaticMap || !path || path.length === 0) {
    return (
      <div className="box p-0">
        <div className="p-16">{locations}</div>
      </div>
    );
  }

  return (
    <div className="box bg-background-secondary-default p-0">
      <StaticImageMap className="h-[148px] flex-1" path={path} />
      <div className="rounded-b-12 bg-background-primary-default p-16">
        {locations}
      </div>
    </div>
  );
};
